import { useMemo } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";

import { useProfile } from "../../../authentication/state/profile";

import useUserOrganizations from "../../hooks/useUserOrganizations";
import isUserOrganization from "../../utils/isUserOrganization";

export default function NarratorOrganizationContext() {
	const { orgId } = useParams();

	const user = useProfile();
	const organizations = useUserOrganizations(user);

	const organization = useMemo(
		() => ({
			id: orgId,
			type: organizationTypes.NARRATOR,
		}),
		[orgId],
	);

	if (user && !isUserOrganization(user, organizations, orgId)) {
		return <Navigate to="/" replace />;
	}

	return <Outlet context={{ organization }} />;
}
